import { createSubjects } from '@openauthjs/openauth/subject'
import { object, string, nullish, record, array } from 'valibot'

export const subjects = createSubjects({
  user: object({
    id: string(),
    firstName: nullish(string()),
    lastName: nullish(string()),
    email: string(),
    locale: nullish(string()),
    permissions: record(string(), array(string())),
  }),
})
